import { Reveal } from "@/components/Reveal";
import { imgSrc } from "@/lib/api";

export const PaymentMethods = ({ methods }) => {
  if (!methods.length) return null;

  return (
    <section id="payment" data-testid="payment-section" className="border-t border-[#282836] py-20 sm:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <Reveal>
          <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#FF5500] mb-3">Checkout made easy</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight mb-14">
            Payment methods accepted
          </h2>
        </Reveal>
        <div className="flex flex-wrap items-center justify-center gap-5">
          {methods.map((m, i) => (
            <Reveal key={m.id} delay={i * 0.06}>
              <div
                data-testid={`payment-method-${m.id}`}
                className="card-glow flex flex-col items-center justify-center gap-4 bg-[#1A1A26] border border-[#282836] rounded-2xl px-10 py-7 min-w-[160px]"
              >
                {m.logo ? (
                  <img src={imgSrc(m.logo)} alt={m.label} className="h-14 w-auto max-w-[140px] object-contain" />
                ) : (
                  <span className="font-display font-semibold text-[#F4F4F8]">{m.label}</span>
                )}
                {m.logo && (
                  <span className="text-xs text-[#9E9EB3]">{m.label}</span>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
